// ©2024 Austin App House. All rights reserved.
import React from 'react';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,
  MDBCol,
  MDBLink,
} from 'mdbreact';

const CertificateCard = ({
  owned, name, cerificateTypeId, openBuyModal, amount,
}) => (
  <MDBCard
    alignment="center"
    style={{ backgroundColor: '#00b4e3', width: '260px', margin: '2rem' }}
  >
    <MDBCardBody style={{ padding: '1.25rem 0 1.25rem 0', textAlign: 'center' }}>
      <MDBCardTitle>{name}</MDBCardTitle>
      <MDBCardText className="text-white">Certificate</MDBCardText>
      {!owned ? (
        <MDBCol
          className="flex-box justify-content-center"
          style={{ padding: '0' }}
        >
          <MDBBtn
            className="btn"
            color="primary"
            onClick={() => openBuyModal(cerificateTypeId)}
            style={{
              padding: '.5rem 1rem',
              border: 'solid 1px black',
              fontSize: '10px',
            }}
          >
            {!amount ? 'Buy now' : `$${amount} Buy now`}
          </MDBBtn>
        </MDBCol>
      ) : (
        <MDBCol
          className="flex-box justify-content-center pad"
          style={{ padding: '0' }}
        >
          <MDBLink
            className="btn btn-primary inline-block"
            to={cerificateTypeId === undefined ? '/' : `/certifications/${cerificateTypeId}/video`}
            style={{
              border: 'solid 1px black',
              fontSize: '10px',
            }}
          >
            Re-watch Video
          </MDBLink>
          <MDBLink
            className="btn btn-primary"
            to={`/certifications/${cerificateTypeId}/tests`}
            style={{
              display: 'inline-block',
              border: 'solid 1px black',
              fontSize: '10px',
            }}
          >
            Retake Exam
          </MDBLink>
        </MDBCol>
      )}
    </MDBCardBody>
  </MDBCard>
);

export default CertificateCard;
